import { fetchApiGateway } from "@nova/fetch-api-gateway"
import { LayerEntityType } from "@nova/schemas"

export const emitLayerProcessed = (
    orgId: string,
    projectId: string,
    layerId: string,
    layerType: LayerEntityType,
    succeeded: boolean
) => {
    return fetchApiGateway("post /org/:orgId/project/:projectId/layer/:layerId/processed", {
        params: { orgId, projectId, layerId },
        body: { layerType, succeeded },
    }).catch((err) => console.error("emitLayerProcessed failed", err))
}
